var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '@appspotr/ui-kit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ModalContentWrapper, ActionBlock, TitleBlock, SubTitleBlock, } from './styles';
import QRCode from 'react-qr-code';
import { Popover } from 'react-tiny-popover';
import { faEye } from '@fortawesome/pro-regular-svg-icons/faEye';
import { TopBarButtonWrapper } from 'app-builder/PublishPopOver/styles';
var PreviewPopOver = function (_a) {
    var isVisiblePreviewPopOver = _a.isVisiblePreviewPopOver, setIsVisiblePreviewPopOver = _a.setIsVisiblePreviewPopOver, app = _a.app;
    var previewUrl = "https://dev-mode-".concat(app.id).concat(process.env.APP_BASE_URL);
    var handleWindowOpen = function () {
        window.open(previewUrl, "App Preview: ".concat(app.id), 'resizable=no,width=400,height=840');
    };
    return (_jsx(Popover, __assign({ isOpen: isVisiblePreviewPopOver, positions: ['bottom'], align: "end", content: _jsxs("div", __assign({ style: {
                zIndex: 1000,
                backgroundColor: '#fff',
                boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                borderRadius: '8px',
            }, onClick: function (e) { return e.stopPropagation(); } }, { children: [' ', _jsx(TitleBlock, { children: "Live Preview" }), _jsx(SubTitleBlock, { children: "Scan the QR code with your device." }), _jsx(ModalContentWrapper, { children: (app === null || app === void 0 ? void 0 : app.id) ? _jsx(QRCode, { size: 244, value: previewUrl }) : 'Loading' }), _jsx(ActionBlock, { children: _jsx(Button, __assign({ onClick: handleWindowOpen, style: {
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                        } }, { children: (app === null || app === void 0 ? void 0 : app.id) ? 'Preview in window' : 'Loading' })) })] })), onClickOutside: function () { return setIsVisiblePreviewPopOver(false); } }, { children: _jsx(TopBarButtonWrapper, { children: _jsx(Button, __assign({ style: {
                    backgroundColor: '#252525',
                    border: '0px solid #252525',
                    color: '#ffffff',
                }, onClick: function () {
                    setIsVisiblePreviewPopOver(!isVisiblePreviewPopOver);
                } }, { children: _jsx(FontAwesomeIcon, { style: { fontSize: '20px' }, color: "#ffffff", icon: faEye }) })) }) })));
};
export default PreviewPopOver;
